import Link from "next/link";

const FooterLogoSection = () => {
  return (
    <Link className="shrink-0" href="/" scroll={false}>
      <img
        alt="Dalal Affiliates Site Image"
        loading="lazy"
        width="267"
        height="192"
        decoding="async"
        data-nimg="1"
        className="object-contain lg:w-66.75 w-100"
        // srcSet="https://www.baghaffiliates.xyz/_next/image?url=%2Fhome%2Fabout-feat.png&w=384&q=75"
        src="/assets/image1.png"
        style={{ color: "transparent" }}
      />
    </Link>
  );
};

export default FooterLogoSection;
